export default __webpack_public_path__ + "static/media/network-graph-1-rMAX.97e27672.jpg";